export enum CarbonThemes {
  WHITE = 'WHITE',
  GRAY_10 = 'GRAY_10',
  GRAY_90 = 'GRAY_90',
  GRAY_100 = 'GRAY_100',
}

export enum CarbonBreakpoints {
  SM = 320,
  MD = 672,
  LG = 1056,
}
